import React, { useState, useEffect } from 'react';
import axios from 'axios';
import toast from 'react-hot-toast';
import Sidebar from '../../components/shared/Sidebar';

const DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
const DAYS_UR = ['Itwar', 'Peer', 'Mangal', 'Budh', 'Jumerat', 'Juma', 'Hafta'];

export default function ShopHours() {
  const [hours, setHours] = useState([]);
  const [saving, setSaving] = useState(false);
  const [slotDuration, setSlotDuration] = useState(30);
  const [slotSaving, setSlotSaving] = useState(false);
  const [autoConfirm, setAutoConfirm] = useState(false);
  const [acSaving, setAcSaving] = useState(false);
  const [blocks, setBlocks] = useState([]);
  const [blockForm, setBlockForm] = useState({ block_date: '', start_time: '', end_time: '', reason: '' });
  const [blockSaving, setBlockSaving] = useState(false);
  const loadBlocks = () => axios.get('/api/shop/time-blocks').then(r => setBlocks(r.data)).catch(() => {});
  const addBlock = async () => {
    if (!blockForm.block_date || !blockForm.start_time || !blockForm.end_time) { toast.error('Date, start aur end time bharein'); return; }
    if (blockForm.end_time <= blockForm.start_time) { toast.error('End time start se baad ho'); return; }
    setBlockSaving(true);
    try {
      await axios.post('/api/shop/time-blocks', blockForm);
      toast.success('Time block add ho gaya!');
      setBlockForm({ block_date: '', start_time: '', end_time: '', reason: '' });
      loadBlocks();
    } catch (e) { toast.error(e.response?.data?.message || 'Error'); }
    setBlockSaving(false);
  };
  const deleteBlock = async (id) => {
    try { await axios.delete(`/api/shop/time-blocks/${id}`); toast.success('Block hata diya'); loadBlocks(); }
    catch { toast.error('Error'); }
  };

  useEffect(() => {
    axios.get('/api/shop/hours').then(r => setHours(r.data));
    axios.get('/api/shop/time-blocks').then(r => setBlocks(r.data)).catch(() => {});
    axios.get('/api/shop/profile').then(r => { if (r.data.slot_duration) setSlotDuration(r.data.slot_duration); setAutoConfirm(!!r.data.auto_confirm); });
  }, []);

  const update = (idx, key, value) => {
    setHours(h => h.map((item, i) => i === idx ? { ...item, [key]: value } : item));
  };

  const handleSlotSave = async () => {
    setSlotSaving(true);
    try { await axios.put('/api/shop/slot-duration', { slot_duration: slotDuration }); toast.success('Slot duration save ho gaya!'); }
    catch { toast.error('Error'); }
    setSlotSaving(false);
  };
  const handleAutoConfirmSave = async (val) => {
    setAutoConfirm(val);
    setAcSaving(true);
    try { await axios.put('/api/shop/auto-confirm', { auto_confirm: val }); toast.success('Setting save ho gayi!'); }
    catch { toast.error('Error'); setAutoConfirm(!val); }
    setAcSaving(false);
  };
  const handleSave = async () => {
    setSaving(true);
    try { await axios.put('/api/shop/hours', { hours }); toast.success('Working hours save ho gayi!'); }
    catch { toast.error('Error'); }
    setSaving(false);
  };

  return (
    <div className="app-layout">
      <Sidebar />
      <div className="main-content">
        <div className="page-header"><h1>Working Hours</h1><p>Har din ke opening aur closing times set karein</p></div>
        <div className="card" style={{ maxWidth: '600px', marginBottom: '20px' }}>
          <h3 style={{ marginBottom: '8px' }}>⏱️ Appointment Slot Duration</h3>
          <p style={{ color: 'var(--text-light)', fontSize: '13px', marginBottom: '16px' }}>Har appointment kitne minute ka hoga (booking slots isi hisaab se banenge)</p>
          <div style={{ display: 'flex', gap: '12px', alignItems: 'center', flexWrap: 'wrap' }}>
            <select className="form-control" style={{ width: '200px' }} value={slotDuration} onChange={e => setSlotDuration(Number(e.target.value))}>
              <option value={10}>10 minute</option>
              <option value={15}>15 minute</option>
              <option value={20}>20 minute</option>
              <option value={30}>30 minute</option>
              <option value={45}>45 minute</option>
              <option value={60}>60 minute (1 ghanta)</option>
            </select>
            <button className="btn btn-primary" onClick={handleSlotSave} disabled={slotSaving}>{slotSaving ? 'Saving...' : '💾 Save'}</button>
          </div>
        </div>
        <div className="card" style={{ maxWidth: '600px', marginBottom: '20px' }}>
          <h3 style={{ marginBottom: '8px' }}>✅ Auto-Confirm Booking</h3>
          <p style={{ color: 'var(--text-light)', fontSize: '13px', marginBottom: '16px' }}>ON: customer booking karte hi slot foran lock ho jayega (aap ko confirm nahi karna). OFF: booking pehle pending aayegi, aap confirm karenge tab slot lock hoga.</p>
          <label style={{ display: 'flex', alignItems: 'center', gap: '12px', cursor: 'pointer' }}>
            <input type="checkbox" checked={autoConfirm} disabled={acSaving} onChange={e => handleAutoConfirmSave(e.target.checked)} style={{ width: '20px', height: '20px', cursor: 'pointer' }} />
            <span style={{ fontWeight: 600 }}>{autoConfirm ? '✅ ON — Booking foran confirm (slot lock)' : '⏳ OFF — Pehle confirm karna hoga'}</span>
          </label>
        </div>
        <div className="card" style={{ maxWidth: '600px', marginBottom: '20px' }}>
          <h3 style={{ marginBottom: '8px' }}>🚫 Time Block (kuch waqt band karein)</h3>
          <p style={{ color: 'var(--text-light)', fontSize: '13px', marginBottom: '16px' }}>Agar kisi din kuch waqt ke liye booking band karni ho (jaise kaam se bahar jana ho), to yahan set karein. Us waqt customer booking nahi kar sakega.</p>
          <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap', alignItems: 'flex-end' }}>
            <div>
              <label className="form-label" style={{ fontSize: '12px' }}>Date</label>
              <input type="date" className="form-control" value={blockForm.block_date} onChange={e => setBlockForm({ ...blockForm, block_date: e.target.value })} style={{ width: '150px' }} />
            </div>
            <div>
              <label className="form-label" style={{ fontSize: '12px' }}>Se</label>
              <input type="time" className="form-control" value={blockForm.start_time} onChange={e => setBlockForm({ ...blockForm, start_time: e.target.value })} style={{ width: '120px' }} />
            </div>
            <div>
              <label className="form-label" style={{ fontSize: '12px' }}>Tak</label>
              <input type="time" className="form-control" value={blockForm.end_time} onChange={e => setBlockForm({ ...blockForm, end_time: e.target.value })} style={{ width: '120px' }} />
            </div>
          </div>
          <div style={{ marginTop: '10px' }}>
            <label className="form-label" style={{ fontSize: '12px' }}>Wajah (optional)</label>
            <input className="form-control" value={blockForm.reason} onChange={e => setBlockForm({ ...blockForm, reason: e.target.value })} placeholder="e.g. Kaam se bahar" style={{ maxWidth: '300px' }} />
          </div>
          <button className="btn btn-primary mt-4" onClick={addBlock} disabled={blockSaving}>{blockSaving ? 'Add ho raha...' : '🚫 Time Block Add Karein'}</button>
          {blocks.length > 0 && (
            <div style={{ marginTop: '20px' }}>
              <h4 style={{ fontSize: '14px', marginBottom: '10px' }}>Aane wale blocks:</h4>
              {blocks.map(b => (
                <div key={b.id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px', background: 'var(--bg)', borderRadius: '8px', marginBottom: '8px' }}>
                  <div style={{ fontSize: '13px' }}>
                    📅 {new Date(b.block_date).toLocaleDateString('en-PK')} — ⏰ {b.start_time?.slice(0,5)} se {b.end_time?.slice(0,5)}{b.reason ? ` (${b.reason})` : ''}
                  </div>
                  <button className="btn" onClick={() => deleteBlock(b.id)} style={{ color: 'var(--danger)', padding: '4px 10px', fontSize: '13px' }}>🗑️ Hataayein</button>
                </div>
              ))}
            </div>
          )}
        </div>
        <div className="card" style={{ maxWidth: '600px' }}>
          {hours.map((h, i) => (
            <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '12px', padding: '14px 0', borderBottom: '1px solid var(--border)' }}>
              <div style={{ width: '90px' }}>
                <div style={{ fontWeight: 600, fontSize: '14px' }}>{DAYS[h.day_of_week]}</div>
                <div style={{ fontSize: '11px', color: 'var(--text-light)' }}>{DAYS_UR[h.day_of_week]}</div>
              </div>
              <label style={{ display: 'flex', alignItems: 'center', gap: '6px', cursor: 'pointer', minWidth: '80px' }}>
                <input type="checkbox" checked={!!h.is_closed} onChange={e => update(i, 'is_closed', e.target.checked)} />
                <span style={{ fontSize: '13px', color: 'var(--danger)' }}>Chutti</span>
              </label>
              {!h.is_closed && (
                <>
                  <input type="time" className="form-control" style={{ width: '120px' }} value={h.open_time?.slice(0,5) || '09:00'} onChange={e => update(i, 'open_time', e.target.value)} />
                  <span style={{ color: 'var(--text-light)' }}>—</span>
                  <input type="time" className="form-control" style={{ width: '120px' }} value={h.close_time?.slice(0,5) || '20:00'} onChange={e => update(i, 'close_time', e.target.value)} />
                </>
              )}
              {h.is_closed && <div style={{ color: 'var(--danger)', fontSize: '13px', fontStyle: 'italic' }}>Band hai</div>}
            </div>
          ))}
          <button className="btn btn-primary mt-4" onClick={handleSave} disabled={saving}>
            {saving ? 'Saving...' : '💾 Hours Save Karein'}
          </button>
        </div>
      </div>
    </div>
  );
}
